export default __webpack_public_path__ + "fd10ad870f295adf7e920c14f43c22a0.svg";